import React, { useContext, useEffect, useRef, useState } from "react";
import { MainStore } from "core/store";
import { Button, Divider, Empty, message, Modal, Segmented } from "antd";
import {
  CalendarFilled,
  CloseCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import CreateLeaveSetup from "./create-leave-setup";
import CardLeaveSetup from "./card-leave-setup";
import dayjs from "dayjs";
import "./style.css";
import ComingSoon from "components/coming-soon";
import AlertError from "containers/profile/alert-error";
import api from "api";

export default function LeaveSetup({ is_comming }) {
  const { userData } = useContext(MainStore);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();

  const [isClosed, setIsClosed] = useState(null);

  const [selectStatus, setSelectStatus] = useState("รายการวันหยุด");
  const [restList, setRestList] = useState([]);
  const [specificDisabledDates, setSpecificDisabledDates] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const [isCreate, setIsCreate] = useState(false);
  const [editId, setEditId] = useState(null);

  const [tfDate, setTfDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [golfCourseStartTime, setGolfCourseStartTime] = useState(null);
  const [golfCourseEndTime, setGolfCourseEndTime] = useState(null);
  const [bookings, setBookings] = useState(null);

  const [leaveDateSelect, setLeaveDateSelect] = useState([]);

  const [isHolliday, setIsHolliday] = useState(0);

  const [selectedDelete, setSelectedDelete] = useState(null);

  const [isSpecific, setIsSpecific] = useState(false);

  const [isCountCurrentPage, setIsCountCurrentPage] = useState(0);

  useEffect(() => {
    getRestList();
  }, []);

  async function getRestList() {
    setIsLoading(true);
    try {
      const { data, status } = await api.caddyApi.getLeaveSetup({
        user_id: userData.user_id,
      });
      const info = data.data;
      if (status === 200) {
        setRestList(info);
        getCurrentPage(info, selectStatus);
        let disable_date_list = [];
        info?.forEach((value) => {
          disable_date_list.push(dayjs(value.date).format("YYYY-MM-DD"));
        });
        setSpecificDisabledDates(disable_date_list);
        GetBookingList();
      } else {
        setRestList([]);
        messageApi.open({
          type: "warning",
          content: "ไม่พบข้อมูลการลาของคุณ.",
        });
      }
      setGolfCourseStartTime(
        dayjs(
          `${dayjs().format("YYYY-MM-DD")} ${
            userData.golf_course.data.tf_start
          }`,
          "YYYY-MM-DD HH:mm:ss"
        )
      );
      setGolfCourseEndTime(
        dayjs(
          `${dayjs().format("YYYY-MM-DD")} ${userData.golf_course.data.tf_end}`,
          "YYYY-MM-DD HH:mm:ss"
        )
      );
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.message,
      });
    } finally {
      setIsLoading(false);
    }
  }

  function getCurrentPage(data, select_status) {
    let count_data_on_page = 0;
    data?.forEach((rest) => {
      const inputDate = dayjs(rest.date);
      const today = dayjs();

      if (
        (inputDate.isAfter(today, "day") &&
          select_status === "รายการวันหยุด") ||
        (inputDate.isSame(today, "day") && select_status === "รายการวันหยุด") ||
        (inputDate.isBefore(today, "day") &&
          select_status === "รายการวันหยุด" &&
          rest.recurring_days !== null &&
          !rest.is_specific_date) ||
        (inputDate.isBefore(today, "day") &&
          select_status === "ประวัติวันหยุด" &&
          rest.is_specific_date)
      ) {
        count_data_on_page = count_data_on_page + 1;
      }
    });

    setIsCountCurrentPage(count_data_on_page);
  }

  async function GetBookingList(isCreate = false) {
    setIsLoading(true);

    if (isCreate) {
      setIsCreate(true);
    }
    try {
      const { data } = await api.caddyApi.getCaddyBooking(userData?.user_id);
      setBookings(data.data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function onDeletedLeaveSetup() {
    setIsLoading(true);
    try {
      await api.caddyApi.deleteLeaveSetup(selectedDelete.id);
      setSelectedDelete(null);
      getRestList();
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  }

  function modalDelete() {
    return (
      <Modal
        open={selectedDelete !== null}
        centered
        footer={false}
        closable={false}
        onClose={() => setSelectedDelete(null)}
      >
        <center>
          <CloseCircleOutlined style={{ color: "red", fontSize: 40 }} />
          <h2 style={{ marginBottom: 5 }}>ลบเวลาไม่รับงาน</h2>
          <div>คุณต้องการลบเวลาไม่รับงานใช่หรือไม่ ?</div>
          <div
            style={{ width: "100%", display: "flex", gap: 10, marginTop: 10 }}
          >
            <Button
              type="primary"
              style={{ width: "100%" }}
              onClick={() => onDeletedLeaveSetup()}
            >
              ตกลง
            </Button>
            <Button
              onClick={() => setSelectedDelete(null)}
              style={{ width: "100%" }}
            >
              ยกเลิก
            </Button>
          </div>
        </center>
      </Modal>
    );
  }

  return !is_comming || is_comming === "false" ? (
    <ComingSoon />
  ) : (
    <div className="leave-setup-container">
      {modalDelete()}
      {contextHolder}

      <div className="leave-setup-header">
        <center>เวลาไม่รับงาน</center>
        <center style={{ fontWeight: "normal", fontSize: 14 }}>
          ของ {userData?.first_name} {userData?.last_name} สนาม{" "}
          {userData?.golf_course?.data?.name}
        </center>
      </div>
      <div className="leave-setup-content">
        {
          <>
            <Button
              onClick={() => {
                GetBookingList(true);
              }}
              style={{
                width: "100%",
                height: 40,
                fontSize: 16,
                color: "white",
                backgroundColor: "#009951",
              }}
            >
              <div>
                <PlusOutlined /> สร้างเวลาไม่รับงานของคุณ
              </div>
            </Button>
            <Divider />
          </>
        }

        {(userData.register_state === 3) | (userData.register_state === 1) ? (
          <AlertError
            isClosed={isClosed}
            setIsClosed={setIsClosed}
            reject_reason={userData.reject_reason}
            register_state={userData.register_state}
          />
        ) : null}

        <center style={{ fontSize: 24, fontWeight: "bold", marginBottom: 15 }}>
          วันหยุดของคุณ
        </center>
        {/* <Segmented
          onChange={(e) => {
            setSelectStatus(e);
            setIsCountCurrentPage(0);
            getCurrentPage(restList, e);
          }}
          style={{ marginBottom: 20, height: 40, alignItems: "center", padding: 5 }}
          options={["รายการวันหยุด", "ประวัติวันหยุด"]}
          block
        /> */}

        {restList?.map((rest) => {
          const inputDate = dayjs(rest.date);
          const today = dayjs();

          if (
            (inputDate.isAfter(today, "day") &&
              selectStatus === "รายการวันหยุด") ||
            (inputDate.isSame(today, "day") &&
              selectStatus === "รายการวันหยุด") ||
            (inputDate.isBefore(today, "day") &&
              selectStatus === "รายการวันหยุด" &&
              rest.recurring_days !== null &&
              !rest.is_specific_date) ||
            (inputDate.isBefore(today, "day") &&
              selectStatus === "ประวัติวันหยุด")
          ) {
            return (
              <CardLeaveSetup
                isHolliday={rest.is_holiday}
                setIsHolliday={setIsHolliday}
                setTfDate={setTfDate}
                endTime={endTime}
                setEndTime={setEndTime}
                startTime={startTime}
                golfCourseStartTime={golfCourseStartTime}
                golfCourseEndTime={golfCourseEndTime}
                setStartTime={setStartTime}
                setStart
                formRef={formRef}
                setEditId={setEditId}
                setIsCreate={setIsCreate}
                data={rest}
                userData={userData}
                selectStatus={selectStatus}
                selectedDelete={selectedDelete}
                setSelectedDelete={setSelectedDelete}
                isSpecific={isSpecific}
                setIsSpecific={setIsSpecific}
                leaveDateSelect={leaveDateSelect}
                setLeaveDateSelect={setLeaveDateSelect}
              />
            );
          } else return false;
        })}

        {isCountCurrentPage === 0 && (
          <div style={{ background: "white", padding: 20, borderRadius: 20 }}>
            <Empty description="ไม่มีข้อมูลการพักของคุณ" />
          </div>
        )}
      </div>
      {isCreate && (
        <CreateLeaveSetup
          isSpecific={isSpecific}
          setIsSpecific={setIsSpecific}
          leaveDateSelect={leaveDateSelect}
          setLeaveDateSelect={setLeaveDateSelect}
          tfDate={tfDate}
          setTfDate={setTfDate}
          bookings={bookings}
          isHolliday={isHolliday}
          setIsHolliday={setIsHolliday}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          golfCourseStartTime={golfCourseStartTime}
          golfCourseEndTime={golfCourseEndTime}
          specificDisabledDates={specificDisabledDates}
          setIsLoading={setIsLoading}
          getRestList={getRestList}
          selectStatus={selectStatus}
          formRef={formRef}
          editId={editId}
          setEditId={setEditId}
          setIsCreate={setIsCreate}
          userData={userData}
          messageApi={messageApi}
        />
      )}
    </div>
  );
}
